import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { Toaster } from 'react-hot-toast'
import './i18n'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnMount: 'always',
      retry: 1,
      // POS must work offline (Local First / Offline Always). Default 'online' pauses all work when navigator.onLine is false.
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
})

// Electron loads dist/index.html via file:// — BrowserRouter path nav breaks (blank screen after login).
const useHash =
  (typeof window !== 'undefined' && window.location.protocol === 'file:') ||
  import.meta.env.VITE_DESKTOP === '1'
const Router = useHash ? HashRouter : BrowserRouter

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <App />
        <Toaster position="top-right" />
      </Router>
    </QueryClientProvider>
  </React.StrictMode>,
)
